import { render, staticRenderFns } from "./PollResultsTableRow.vue?vue&type=template&id=5c70f17a&scoped=true"
import script from "./PollResultsTableRow.vue?vue&type=script&lang=js"
export * from "./PollResultsTableRow.vue?vue&type=script&lang=js"
import style0 from "./PollResultsTableRow.vue?vue&type=style&index=0&id=5c70f17a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70f17a",
  null
  
)

export default component.exports